import React, { useState } from 'react';
import CircleChart from '../../../circle-chart/CircleChart';
import { TriangleSlider } from '../../../slider';
import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { AppConfigs, AppSkinProps, ColorSettings } from '../../../../types/decisions';
import MultiColorSelector from '../../../MultiColorSelector';

const AppCriteriaTypeColor = ({
    importance,
    hideValues,
    hideImportance,
    onSliderChange,
    onTradeoffValueChange,
    id,
    showAddConstraint,
    value,
    variant = 'MultipleColors',
    disabled = false,
}: {
    importance: number;
    hideValues?: boolean;
    hideImportance?: boolean;
    showAddConstraint?: boolean;
    onSliderChange: AppSkinProps['onSliderChange'];
    onTradeoffValueChange: (value: any, id: string, key: string) => void;
    id: string;
    value: {
        color: string;
        isSelected: boolean;
    }[];
    variant?: AppConfigs['criteriaSettings']['color'];
    disabled?: boolean;
}) => {
    const [ colors, setColor ] = useState<ColorSettings[]>(value);

    const onColorSelect = (index: number) => {
        if (disabled) {
            return;
        }

        setColor((prev) => {
            const selectedColors = prev.map((item, idx) => {
                if (idx === index) {
                    return {
                        color: item.color,
                        isSelected: !item.isSelected,
                    };
                }
                return item;
            });

            onTradeoffValueChange(selectedColors, id, '');
            return selectedColors;
        });
        // TODO optimize
    };

    const onColorChange = (index: number, isSelected: boolean, newColor: string) => {
        if (disabled) {
            return;
        }

        setColor((prev) => {
            const selectedColors = prev.map((item, idx) => {
                if (idx === index) {
                    return {
                        color: newColor,
                        isSelected: isSelected,
                    };
                }
                return item;
            });

            onTradeoffValueChange(selectedColors, id, '');
            return selectedColors;
        });
        // TODO optimize
    };

    return (
        <div>
            {hideValues ? null : (
                <div style={{ marginBottom: 10, display: 'flex', justifyContent: 'center' }}>
                    {variant === 'SingleColor' ? (
                        <CircleChart onColorSelect={onColorSelect} colors={colors}/>
                    ) : (
                        <MultiColorSelector onColorChange={onColorChange} colors={colors}/>
                    )}
                </div>
            )}
            {hideImportance ? null : (
                <div>
                    <TriangleSlider
                        min={0}
                        max={100}
                        step={1}
                        value={importance}
                        leftText="Not Important"
                        rightText="Really Important"
                        onChange={(_, value) => onSliderChange(value as number, id)}
                        disabled={disabled}
                    />
                </div>
            )}
            {!showAddConstraint ? null : (
                <div style={{ marginTop: 20 }}>
                    <Button
                        variant="outlined"
                        startIcon={<AddIcon/>}
                        size="small"
                        disabled={disabled}
                    >
                        Add Constraint
                    </Button>
                </div>
            )}
        </div>
    );
};

export default AppCriteriaTypeColor;
